import axios from 'axios'
import router from '@/router'
import { VuexStore } from "@/core/storage"
import dialog from '@/components/dialog'

// 创建axios实例
const service = axios.create({
    timeout: 1000 * 30,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
    }
})

// request拦截器
service.interceptors.request.use(config => {
    try {
      JSON.parse(config.data);
      config.headers['Content-Type'] = 'application/json; charset=utf-8';
    } catch (e) {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=utf-8';
    }
    let token = VuexStore.getValue('token');
    if (token != null)
        config.headers['Authorization'] = token;
    return config
}, error => {
    return Promise.reject(error)
})

// response拦截器
service.interceptors.response.use(response => {
    if (response.data && response.data.errorCode === "UNAUTHORIZED_LOGIN") { // 401, token失效
        dialog.closeAll();
        router.push({ name: 'login' })
    }
    else {
        if (response.headers["refreshedtoken"] != null) {
            VuexStore.storageValue('token', response.headers["refreshedtoken"]);
        }
    }
    return response
}, error => {
    let response = error.response;

    if (response && response.data) {
        dialog.closeAll();
        if (response.data.errorCode === 'UNAUTHORIZED_LOGIN')
            router.push({ name: 'login' })
        return Promise.reject(response.data);
    }
    else {
        return Promise.reject({
            errorMessage: '数据获取失败，请稍后再试'
        });
    }
})

export default service



// WEBPACK FOOTER //
// ./src/core/http/request.js